module.exports = __webpack_public_path__ + "d9eac88742d9ab98a2dba1ece344ed0c.MP3";